import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetOrganizationParams, GetOrganizationOptions, OrgMemberRoleAndPrivileges } from '@nx-frontend/shared/types';

export async function getUserRole(
  { globalId }: GetOrganizationParams,
  options: GetOrganizationOptions
): Promise<OrgMemberRoleAndPrivileges> {
  const { userId } = options;
  let role: OrgMemberRoleAndPrivileges | null = null;

  const response = await axiosClient.get<OrgMemberRoleAndPrivileges>(
    `${generalEnv.orgServiceUrl}/v1/orgs/${globalId}/userRole`,
    {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    }
  );
  role = response.data;

  return role;
}
